import axios from "axios"

import init from "../../shared/utils/init"

init(() => {
  const input = document.querySelector(
    `.mission-search-page-form input[type="search"]`
  )

  const clearInputEl = document.querySelector(
    `.mission-search-page-form .js--input-clear`
  )

  if (!input) return

  const form = input.closest(`form`)
  if (!form) return

  const resultsRow = document.querySelector(`#organization-application-page`)
  if (!resultsRow) return

  const csrfTag = document.querySelector(`meta[name="csrf-token"]`)
  if (csrfTag) {
    axios.defaults.headers.common[`X-CSRF-Token`] = csrfTag.content
  }

  input.disabled = false

  // Reuse existing org_id input
  const orgIdInputEl = form.querySelector(`#sign_up_org_form_org_id`)

  // Read no-results text from data attribute so it can be translated server-side
  const noResultsText = resultsRow.dataset.noResultsText
  const resultsFoundText = resultsRow.dataset.resultsFoundText
  const resultsPossibleText = resultsRow.dataset.resultsPossibleText
  const resultsSuffixText = resultsRow.dataset.resultsSuffixText

  const MIN_QUERY_LENGTH = 2
  const DEBOUNCE_MS = 250

  let debounceTimeout = null
  let selectedOrgId = null
  let currentQuery = ``

  const escapeHtml = (str = ``) =>
    str
      .replace(/&/g, `&amp;`)
      .replace(/</g, `&lt;`)
      .replace(/>/g, `&gt;`)
      .replace(/"/g, `&quot;`)
      .replace(/'/g, `&#039;`)

  const normalizeName = (name = ``) => name.trim().toLowerCase()

  const highlightMatch = (text, query) => {
    const safeText = escapeHtml(text || ``)
    const q = (query || ``).trim()

    if (!q) return safeText

    const escapedQuery = q.replace(/[.*+?^${}()|[\]\\]/g, `\\$&`)
    const regex = new RegExp(escapedQuery, `gi`)

    return safeText.replace(
      regex,
      (match) => `<mark class="search--match">${match}</mark>`
    )
  }

  const updateButtonsUI = () => {
    const buttons = resultsRow.querySelectorAll(`.js-org-select-btn`)

    buttons.forEach((button) => {
      const { orgId } = button.dataset
      const isSelected = selectedOrgId && selectedOrgId === orgId
      const textEl = button.querySelector(`.btn__text`) || button

      textEl.textContent = isSelected ? `Vald` : `Välj`

      button.classList.toggle(`btn--primary`, !isSelected)
      button.classList.toggle(`btn--secondary`, isSelected)
      button.setAttribute(`aria-pressed`, isSelected ? `true` : `false`)
    })

    if (orgIdInputEl) {
      orgIdInputEl.value = selectedOrgId || ``
    }
  }

  const handleSelectClick = (event) => {
    const button = event.target.closest(`.js-org-select-btn`)
    if (!button) return

    const { orgId } = button.dataset
    if (!orgId) return

    // Toggle selection
    if (selectedOrgId === orgId) {
      selectedOrgId = null
      setDisableSubmitButton(true)
    } else {
      selectedOrgId = orgId
      setDisableSubmitButton(false)
    }

    updateButtonsUI()
  }

  const renderResults = (items) => {
    resultsRow.innerHTML = ``

    updateResultsAmount(items?.length || 0)

    if (!items || !items.length) {
      updateStatusMessage(noResultsText)
      selectedOrgId = null
      updateButtonsUI()
      if (orgIdInputEl) orgIdInputEl.value = `new_org`
      setDisableSubmitButton(false)

      return
    }

    const hasExactMatch = items.some(
      (item) => normalizeName(item.name) === normalizeName(currentQuery)
    )

    setDisableSubmitButton(hasExactMatch)

    items.forEach((item) => {
      const itemWrapper = document.createElement(`div`)
      itemWrapper.className = `organizations-list__row`

      itemWrapper.innerHTML = `
        <div class="-title">
          ${highlightMatch(item.name, currentQuery)}
        </div>
        <button
          type="button"
          class="btn btn--primary btn--xs js-org-select-btn"
          data-org-id="${item.id}"
          aria-pressed="false"
        >
          <span class="btn__text">
            Välj
          </span>
        </button>
      `

      resultsRow.appendChild(itemWrapper)
    })

    if (items.length > 0) {
      updateStatusMessage(
        hasExactMatch ? resultsFoundText : resultsPossibleText
      )
    }

    updateButtonsUI()
  }

  const fetchResults = (query) => {
    axios
      .get(`/api/v1/organizations.json`, {
        params: { q: query },
      })
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : []
        renderResults(data)
      })
      .catch(() => {
        renderResults([])
      })
  }

  const onInput = (event) => {
    const value = event.target.value.trim()
    currentQuery = value

    if (debounceTimeout) window.clearTimeout(debounceTimeout)

    if (value.length < MIN_QUERY_LENGTH) {
      resultsRow.innerHTML = ``
      selectedOrgId = null
      updateButtonsUI()
      if (clearInputEl) clearInputEl.style.display = `none`
      return
    }

    if (clearInputEl) clearInputEl.style.display = `block`

    debounceTimeout = window.setTimeout(() => {
      fetchResults(value)
    }, DEBOUNCE_MS)
  }

  const updateStatusMessage = (message) => {
    document.querySelector(`#org-status-message`).textContent = message
  }

  const updateResultsAmount = (value) => {
    document.querySelector(
      `#org-results-suffix`
    ).textContent = `${value} ${resultsSuffixText}`
  }

  const setDisableSubmitButton = (disabled) => {
    document.querySelector(`.-js-continue-btn`).disabled = disabled
  }

  resultsRow.addEventListener(`click`, handleSelectClick)
  input.addEventListener(`input`, onInput)

  if (clearInputEl) {
    clearInputEl.addEventListener(`click`, () => {
      input.value = ``
      input.focus()
      clearInputEl.style.display = `none`
      currentQuery = ``
    })
  }

  // Initial sync
  updateButtonsUI()
})
